import React, { useEffect, useState } from 'react';
import { globals } from '../../misc/globals';
import { setFocus } from '../../misc/tools';
import { BaseConfig } from '../BaseConfig';
import { UIProperties } from '../UIProperties';

import './ContinueButton.css'

const ContinueButton = (props: UIProperties<ContinueButtonConfig>) => {
	const [isOver, setIsOver] = useState(false);
	useEffect(() => {

	}, [isOver])

	return (
		<div className='modal-disable-select' style={{
			position: 'absolute',
			top: props.parameters.top,
			left: props.parameters.left,
			width: props.parameters.width
		}}>
			<button id={props.parameters.id} tabIndex={0} aria-label={ props.parameters.ariaLbl ?? 'continue'} className="pointer" style={{
				position: 'relative',
				background: 'transparent',
				pointerEvents: props.parameters.isDisabled ? 'none' : 'all'
			}} onKeyDown={(e) => {
				if(props.parameters.isPR && (e.key === 'Tab' || e.which === 9) && e.shiftKey) {
					setFocus('pr-tab-3');
					e.preventDefault();
				}
			}} 
			aria-disabled={props.parameters.isDisabled}
			onMouseOver={() => {
                if(props.parameters.highlightOnHover) {
                    setIsOver(true);
                }
			}} onMouseEnter={() => {
				var rollOverAudio = document.getElementById('button-rollover');
				if(!globals.isMuted) {
					(rollOverAudio as any).play();
				}
			}} onMouseDown={() => {
				setIsOver(true);
			}} onMouseUp={() => {
				setIsOver(false);
			}} onMouseOut={() => {
				setIsOver(false);
			}} onClick={() => {
				if(props.parameters.isDisabled) {
					return;
				}
				var clickAudio = document.getElementById('button-click');
				if(!globals.isMuted) {
					(clickAudio as any).play();
				}
				if(props.parameters.onClicked) {
					props.parameters.onClicked();
				}
			}}>
				{props.parameters.isClose ? (
					<div>
					{<img style={{
						pointerEvents: 'none'
					}} src={props.parameters.srcMain ? props.parameters.srcMain : "./assets/images/general/buttons/button_close_main.png"} />}
					{isOver ? (<img style={{
						position: 'absolute',
						top: '0',
						left: '0',
						width: '100%',
						height: '100%',
						pointerEvents: 'none'
					}} src={props.parameters.srcDown ? props.parameters.srcDown : "./assets/images/general/buttons/button_close_down.png" }/>) : (<div></div>)}
					{props.parameters.isDisabled ? (<img style={{
						position: 'absolute',
						top: '0',
						left: '0',
						width: '100%',
						height: '100%',
						pointerEvents: 'none'
					}} src={props.parameters.srcDisabled ? props.parameters.srcDisabled :"./assets/images/general/buttons/button_close_disabled.png"} />) : (<div></div>)}
					</div>
				):(
					<div>
					{<img style={{
					pointerEvents: 'none'
                }} src={props.parameters.srcMain ? props.parameters.srcMain : "./assets/images/general/buttons/button_continue_main.png" }/>}
				{isOver ? (<img style={{
					position: 'absolute',
					top: '0',
					left: '0',
					width: '100%',
					height: '100%',
					pointerEvents: 'none'
				}} src={props.parameters.srcDown ? props.parameters.srcDown :"./assets/images/general/buttons/button_continue_down.png" }/>) : (<div></div>)}
				{props.parameters.isDisabled ? (<img style={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: '100%',
                    pointerEvents: 'none'
                }} src={props.parameters.srcDisabled ? props.parameters.srcDisabled :"./assets/images/general/buttons/button_continue_disabled.png"} />) : (<div></div>)}
				</div>
				)}

				{/* {<img style={{
					pointerEvents: 'none'
                }} src="./assets/images/general/buttons/button_continue_main.png" />}
				{isOver ? (<img style={{
					position: 'absolute',
					top: '0',
					left: '0',
					width: '100%',
					height: '100%',
					pointerEvents: 'none'
				}} src="./assets/images/general/buttons/button_continue_down.png" />) : (<div></div>)}
				{props.parameters.isDisabled ? (<img style={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: '100%',
                    pointerEvents: 'none'
                }} src="./assets/images/general/buttons/button_continue_disabled.png" />) : (<div></div>)} */}

			</button>
		</div>
	);

};

export interface ContinueButtonConfig extends BaseConfig{
	top: string;
	left: string;
	ariaLbl?: string;
	isPR?: boolean;
	srcMain?: string;
	srcDown?: string;
	srcDisabled?: string;
	width: string;
	isDisabled?: boolean;
	highlightOnHover?: boolean;
	isClose?: boolean;
	id?: string;
	onClicked: () => void;
}

export default ContinueButton;